import { TARGETS, FEATURE_FLAGS, fetchFlag } from '@marriott/mi-feature-flag-utils';
const targetMap = {
  // Account renderer
  account: { target: TARGETS.APP.ACCOUNT_RENDERER, enableStream: true },

  // Shop renderer
  'shop-spa': { target: TARGETS.APP.SHOP_RENDERER, enableStream: true },

  // Groups renderer
  migroups: { target: TARGETS.APP.GROUPS_RENDERER, enableStream: true },
  groups: { target: TARGETS.APP.GROUPS_RENDERER, enableStream: true }, // alternative env name

  // Luxury renderer
  luxury: { target: TARGETS.APP.LUXURY_RENDERER, enableStream: true },

  // Offers renderer
  'mi-aem-offers-spa': { target: TARGETS.APP.OFFERS_RENDERER, enableStream: true },

  // Leisure renderer
  'mi-aem-leisure-spa': { target: TARGETS.APP.LEISURE_RENDERER, enableStream: true },

  // Homepage renderer
  homepage: { target: TARGETS.APP.HOMEPAGE_RENDERER, enableStream: true },
  'homepage-spa': { target: TARGETS.APP.HOMEPAGE_RENDERER, enableStream: true },

  // Cobrand renderer
  cobrand: { target: TARGETS.APP.COBRAND_RENDERER, enableStream: true },

  // PPV5 renderer
  'ppv5-phoenix': { target: TARGETS.APP.PPV5_RENDERER, enableStream: true },
  'mi-aem-ppv5-spa': { target: TARGETS.APP.PPV5_RENDERER, enableStream: true },

  // Landing page renderer
  landingpage: { target: TARGETS.APP.LANDINGPAGE_RENDERER, enableStream: true },
  'landingpage-spa': { target: TARGETS.APP.LANDINGPAGE_RENDERER, enableStream: true },
  'mi-aem-landing-spa': { target: TARGETS.APP.LANDINGPAGE_RENDERER, enableStream: true }, // production env name

  // Brands renderer
  brands: { target: TARGETS.APP.BRANDS_RENDERER, enableStream: true },
  'mi-aem-brands': { target: TARGETS.APP.BRANDS_RENDERER, enableStream: true },
  'brands-spa': { target: TARGETS.APP.BRANDS_RENDERER, enableStream: true }, // alternative env name

  // Legal renderer
  legal: { target: TARGETS.APP.LEGAL_RENDERER, enableStream: true },
  'mi-aem-legal-spa': { target: TARGETS.APP.LEGAL_RENDERER, enableStream: true },

  // Contactless renderer
  'contactless-phoenix': { target: TARGETS.APP.CONTACTLESS_RENDERER, enableStream: true },
  'mi-aem-contactless-spa': { target: TARGETS.APP.CONTACTLESS_RENDERER, enableStream: true },

  //Category renderer
  'mi-aem-category-spa': { target: TARGETS.APP.CATEGORY_RENDERER, enableStream: true },

  // Chat renderer
  'chat-spa': { target: TARGETS.APP.CHAT_RENDERER, enableStream: true },
  codegen: { target: TARGETS.APP.CHAT_RENDERER, enableStream: true },

  // AWP renderer
  awp: { target: TARGETS.APP.AWP_RENDERER, enableStream: true },

  // Common renderer
  'common-spa': { target: TARGETS.APP.COMMON_RENDERER, enableStream: true },

  // Groups renderer
  'groups-spa': { target: TARGETS.APP.GROUPS_RENDERER, enableStream: true },

  // GRT renderer
  grt: { target: TARGETS.APP.GRT_RENDERER, enableStream: true },

  // HWS renderer
  'hws-spa': { target: TARGETS.APP.HWS_RENDERER, enableStream: true },

  // MarTech renderer
  martech: { target: TARGETS.APP.MARTECH_RENDERER, enableStream: true },
  prearrival: { target: TARGETS.APP.MARTECH_RENDERER, enableStream: true }, // development env name

  // MDS renderer
  'mds-spa': { target: TARGETS.APP.MDS_RENDERER, enableStream: true },

  // Pre-arrival renderer (no NEXT_PUBLIC_APP_NAME found in .env or YAML files - renderer can't use sensitive header feature flag)
  'mi-prearrival-renderer': { target: TARGETS.APP.PREARRIVAL_RENDERER, enableStream: true },

  // TRC renderer (no NEXT_PUBLIC_APP_NAME found in .env or YAML files - renderer can't use sensitive header feature flag)
  'mi-trc-renderer': { target: TARGETS.APP.TRC_RENDERER, enableStream: true },
};

// Get the feature flag configuration (target + enableStream) based on the app name
export const getFeatureFlagConfig = (appName: string) => {
  return targetMap[appName as keyof typeof targetMap] || null;
};

interface Logger {
  debug: (message: string) => void;
  error: (message: string, error?: unknown) => void;
}

// Function to fetch sensitive header filter feature flag
export const fetchHeaderFilterFeatureFlag = async (appName: string, logger?: Logger) => {
  try {
    const config = getFeatureFlagConfig(appName);
    if (!config) {
      logger?.debug(`No config found for app: ${appName}`);
      return false;
    }

    const headerFilterFlag = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_SENSITIVE_HEADERS_FILTER, {
      target: config.target,
      enableStream: config.enableStream,
    });

    return headerFilterFlag[FEATURE_FLAGS.EXPERIENCE_MCOM_SENSITIVE_HEADERS_FILTER] || false;
  } catch (error) {
    logger?.error('Error fetching header filter feature flag:', error);
    return false;
  }
};
